import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import Layout from "@/components/Layout";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <h1 className="font-heading text-8xl font-bold text-primary mb-4">404</h1>
          <h2 className="font-heading text-2xl font-bold text-foreground mb-4">
            {t("notfound.title")}
          </h2>
          <p className="text-muted-foreground mb-8">{t("notfound.subtitle")}</p>
          <Button asChild size="lg">
            <Link to="/">
              <Home className="h-5 w-5" />
              {t("notfound.home")}
            </Link>
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
